import { apiCustomer } from '@/api'
import verifyUser from '@/lib/verify-user'

async function deleteAddress(addressId: string) {
  await verifyUser()

  return apiCustomer.delete(`/addresses/${addressId}`)
    .then(response => response.data)
    .catch(() => {
      throw new Error("something went wrong deleting address")
    })
}

export default deleteAddress
